import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { GridInputs } from "../../../../../components/Functional";
import { Button } from "../../../../../components/ui";

const descriptionSchema = Yup.object({
  description: Yup.string().trim().required("Description is required"),
});

const AddRecordForm = props => {
  const {
    closeModal,
    initialValues = { description: "" },
    inputs = [{ label: "Description", name: "description", type: "text" }],
    loading,
    onSubmit,
    title,
    validationSchema = descriptionSchema,
  } = props || {};
  const [error, setError] = useState(null);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async values => {
      const submitError = await onSubmit(values);
      if (submitError) {
        setError(submitError);
        return;
      }
      closeModal?.();
    },
  });

  const inputProps = {
    className: "grid grid-cols-1 gap-4",
    formik,
    inputs: [{ className: "grid grid-cols-1 gap-4", inputs }],
  };

  return (
    <div className="flex w-full flex-col p-4 sm:p-6 lg:p-8">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="flex flex-1 flex-col text-2xl font-bold">{title}</div>
        <div className="flex flex-wrap gap-4">
          <Button action="default" label="Cancel" onClick={closeModal} />
          <Button
            label={loading ? "Saving" : "Add"}
            disabled={loading || !formik.isValid}
            onClick={formik.submitForm}
          />
        </div>
      </div>
      {error && (
        <div role="alert" className="pt-4 text-sm text-red-600">
          {error}
        </div>
      )}
      <div className="mt-8 pb-6">
        <GridInputs {...inputProps} />
      </div>
    </div>
  );
};

export default AddRecordForm;
